export default {
    namespaced: true,
    state: {
        priceUnitOptions: [
            {
                id: '1',
                title: 'за штуку',
                abbr: 'шт'
            },
            {
                id: '2',
                title: 'за грамм',
                abbr: 'гр'
            },
            {
                id: '3',
                title: 'за пару',
                abbr: 'пара'
            }
        ],
        visibilityOptions: [
            {
                id: 0,
                title: 'Не видно никому',
                descr:
                    ' Изделие не видно ни одному ритейлеру.<br>Подписавшиеся на ваш бренд ритейлеры не получают оповещение о регистрации новинки. <br> Изделие не отображается розничным покупателям.'
            },
            {
                id: 2,
                title: 'Видно всем',
                descr:
                    'Изделие видно всем ритейлерам.<br>Все подписавшиеся на ваш бренд ритейлеры получают оповещение о регистрации новинки.  <br> Изделие отображается розничным покупателям.'
            },
            {
                id: 1,
                title: 'Ограниченный доступ',
                descr:
                    'Изделие видно только ритейлерам, которым вы дали доступ.<br>Ритейлеры с доступом получают оповещение о регистрации новинки.  <br>Изделие не отображается розничным покупателям.'
            }
        ],
        supplierVisibilityValues: [],
        errors: {
            getVisibility: ''
        }
    },
    getters: {
        supplierVisibility(state) {
            return state.visibilityOptions.filter(
                item => state.supplierVisibilityValues.indexOf(item.id) > -1
            )
        },
        //values for supplier products page filter, default all
        visibilityOptionsArr(state, getters) {
            return getters.supplierVisibility.map(item => item.id)
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        SET_SUPPLIER_VISIBILITY(state, payload) {
            state.supplierVisibilityValues = payload
        }
    },
    actions: {
        async getVisibility({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getVisibility',
                val: ''
            })

            const url = '/public/dict/accesses'

            try {
                const resp = await this.$axios
                    .get(url, {
                        params: data
                    })
                    .then(res => {
                        return res.data
                    })

                if (data && data.existing) {
                    commit('SET_SUPPLIER_VISIBILITY', resp)
                }
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getVisibility',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getVisibility',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
